import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RenderInput } from './Base';
import { Viewer } from "../../../widgets/Viewer";

import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';
import { getYearsArray } from '../../../../helpers/functions';

import { saveReportCard } from '../../../../redux/actions/reportCard.actions';

const mapStateToProps = (state, ownProps) => ({
    reportCard: state.reportCard
});

class AddReportCardModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            date_written: new Date(),
            filename: '',
            image: '',
            dropbox_image_share_url: ''
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
        this.years = getYearsArray();
    }
    componentDidMount() {
        window.addEventListener('open-report-card-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-report-card-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { reportCard: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value, file }) => {
        const { form } = this.state;

        // Extract last file
        if (file && file[0]) {
            const reader = new FileReader();
            const lastFile = file[0];
            reader.readAsDataURL(lastFile);
            reader.onloadend = () => {
                form.image = reader.result;
                this.setState({ form });
            }
            form.filename = lastFile.name;
        }
        if (text !== undefined) {
            form[value] = text;
        }

        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveProgress();
        }
    }
    saveReportCard = () => {
        const newForm = { ...this.state.form }
        if (newForm.image) {
            newForm.image = newForm.image.split(',')[1];
        }
        this.props.saveReportCard(newForm);
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.reportCard;
        return (
            <Dialog icon='list-detail-view'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                canOutsideClickClose={false}
                title="Add Report Card">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="Date Written"
                                    name="date_written"
                                    value={form.date_written}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput name="filename"
                                    type="upload"
                                    value={form.filename}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                { form.image || form.dropbox_image_share_url ?
                                     <div className="flex-column">
                                        <Viewer src={form.image || form.dropbox_image_share_url || ''} style={{ width: '100%' }} />
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Save Report Card" onClick={this.saveReportCard} isLoading={saveLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveReportCard }
)(AddReportCardModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/ReportCardModal.jsx